// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__3sdqI","selected":"Chip_selected__1Ra92"};